import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const MessageIcon = ({
  title = 'Message',
  viewBox = '0 0 24 24',
  color = 'currentColor',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props} fill="none">
    <path
      d="m12 20-3-3H7a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2l-3 3M8 9h8M8 13h6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default MessageIcon;
